import { addLayer, removeLayer, addLayerEvent } from '../layers/layer_helpers';
import { createPolylineLayer } from '../layers/polylines';
import { addOrUpdateGeojsonSource } from '../sources/geojson_helpers';
import { addHoverPopupToMap } from '../event_handling/popup_helpers';
import { removeSource } from '../sources/source_helpers';

const addPolylines = (map, id, geojson, opts = {}, addUnderLayerTypes = null) => {
  addOrUpdateGeojsonSource(map, id, geojson);
  if (map.getLayer(id)) {
    return;
  }
  addLayer(map, createPolylineLayer(id, id, opts), addUnderLayerTypes);
  if (opts && opts.renderPopup) {
    addLayerEvent(map, id, true, 'mouseenter', () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    addLayerEvent(map, id, true, 'mouseleave', () => {
      map.getCanvas().style.cursor = map.customStyle.cursor;
    });

    addHoverPopupToMap(map, id, opts.renderPopup);
  }
};

const removePolylines = (map, id) => {
  removeLayer(map, id);
  removeSource(map, id);
};

export { addPolylines, removePolylines };
